module.exports = __webpack_public_path__ + "img/engine-oil-filter.691f61b0.png";